'use client';

import { SessionProvider, SessionProviderProps } from 'next-auth/react';
import { useEffect } from 'react';

import { signIn } from '@helpers/authentication';
import { localApiPaths } from '@helpers/path';
import { isSessionExpired } from '@helpers/session';

export function AuthProvider({ children, session }: SessionProviderProps) {
    useEffect(() => {
        if (isSessionExpired(session)) {
            document.cookie = 'next-session-token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
            void signIn();
        }
    }, [session?.user?.sub, session?.user?.exp]);

    return (
        <SessionProvider session={session} basePath={localApiPaths.auth}>
            {children}
        </SessionProvider>
    );
}
